module.exports = __webpack_public_path__ + "img/Carina Nebula Splash Screen Close.7714539e.png";